export default __webpack_public_path__ + "static/media/lap_image4.62f2335f.webp";